import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "../src/Assets/css/custom.css";
import store from './Redux/Store'
import {Provider} from 'react-redux'



ReactDOM.render(
  <>
  <Provider store={store}> 
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </Provider>
  </>,
  document.getElementById("root")
);
